module.exports = __webpack_public_path__ + "assets/img/KeyReport_Picto1.aec6ee6d.svg";